<template>
  <div class="about ma-5">
    <v-form ref="form"
            v-model="valid"
            :lazy-validation="lazy"
            justify="space-around"
            class="ma-2">
      <v-text-field v-model="name"
                    :rules="nameRules"
                    label="Name"
                    required>
      </v-text-field>

      <v-text-field v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required>
      </v-text-field>

      <v-select v-model="select"
                :items="items"
                :rules="[v => !!v || 'An selected option is required']"
                label="Choose an option"
                required>
      </v-select>

      <v-checkbox v-model="checkbox"
                  :rules="[v => !!v || 'You must agree to continue!']"
                  label="Do you agree with our terms and services?"
                  required>
      </v-checkbox>
      <v-textarea v-model="title"
                  :rules="messageRules"
                  label="Message"
                  counter
                  maxlength="230"
                  auto-grow
                  single-line>
      </v-textarea>
      <v-btn :disabled="!valid"
             color="success"
             class="mr-4"
             @click="validate">
        Send ticket
      </v-btn>

      <v-btn color="error"
             class="mr-4"
             @click="reset">
        Cancel
      </v-btn>
    </v-form>
  
  <!-- SnackBar conclusion -->
  <div class="text-center ma-2">
    <v-snackbar v-model="snackbar"
                top>
      Your message was sent
      <v-btn color="pink"
             text
             @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
  </div>
</template>


<script>
export default {
  data: () => ({
    checkbox: false,
    lazy: true,
    select: null,
    snackbar: false,
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    items: [
      'Item 1',
      'Item 2',
      'Item 3',
      'Item 4',
    ],
    messageRules: [
      v => !!v || 'Message required',
      v => (v && v.length >= 50) || 'Message must have more than 50 characters',
      v => (v && v.length <= 230) || 'Message has an limit of 230 characters' 
    ]
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$refs.form.reset();
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
